import React, { useState } from "react";
import Form from "../../../components/Form";
import CountrySelect from "../../../components/ui/Inputs/CountrySelect";
import { useAlertsContext } from "../../../hooks/useAlertsContext";
import { ContactUs } from "../../../modules/common/service";
import { Contact, ContactFormValues } from "../../../utils/types";

const inputs = [
  {
    id: 1,
    label: "Full Name*",
    name: "fullName",
    placeholder: "Full Name",
    required: true,
    value: "",
  },
  {
    id: 2,
    label: "Company",
    name: "company",
    placeholder: "Company",
    value: "",
  },
  {
    id: 3,
    label: "Email*",
    name: "email",
    placeholder: "Email",
    type: "email",
    required: true,
    value: "",
  },
  {
    id: 4,
    label: "Telephone*",
    name: "telephone",
    placeholder: "Telephone",
    type: "tel",
    required: true,
    value: "",
  },
  {
    id: 5,
    label: "Country",
    name: "country",
    placeholder: "Country",
    component: CountrySelect,
    value: "",
  },
  {
    id: 6,
    label: "Subject",
    name: "subject",
    placeholder: "Subject",
    value: "",
  },
  {
    id: 7,
    label: "Message",
    name: "message",
    placeholder: "Message",
    textArea: true,
    value: "",
  },
];

const initialValues: ContactFormValues = {
  fullName: "",
  company: "",
  email: "",
  telephone: "",
  country: "",
  subject: "",
  message: "",
};
type Props = {
  callBack?: Function;
};
const ContactForm: React.FC<Props> = ({ callBack }) => {
  const { toastSuccess, toastError } = useAlertsContext();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] =
    React.useState<ContactFormValues>(initialValues);

  const handleSubmitContactUs = async (values: ContactFormValues) => {
    setLoading(true);
    const formValues: Contact = {
      name: values.fullName,
      email: values.email,
      phoneNumber: values.telephone,
      info: values.message,
      subject: values.subject,
      company: values.company,
      country: values.country,
    };
    // Handle submission for contact us form
    await ContactUs(formValues)
      .then((response) => {
        toastSuccess(response || "Form Submitted Successfully");
        setFormValues(initialValues);
        callBack &&
          setTimeout(() => {
            callBack();
          }, 1000);
      })
      .catch((e) => toastError(e?.data))
      .finally(() => setLoading(false));
  };

  const handleResetContactUs = () => {
    // Handle reset for contact us form
    setFormValues(initialValues);
  };
  return (
    <Form
      inputs={inputs}
      formValues={formValues}
      setFormValues={setFormValues}
      onSubmit={handleSubmitContactUs}
      onReset={handleResetContactUs}
      loading={loading}
    />
  );
};
export default ContactForm;
